import React from "react";
import { buildReport, downloadReport } from "../../utils/exportReport";

export default function WorkflowCompletionScreen({ state, onRestart }) {
  if (!state || state.status !== "completed") return null;
  const totalMs = new Date(state.completedAt) - new Date(state.startedAt);
  const days = Math.floor(totalMs / (24 * 60 * 60 * 1000));
  const hours = Math.floor(
    (totalMs % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000),
  );

  return (
    <div className="completion-screen">
      <div className="checkmark">✓</div>
      <h2>{state.workflowName} Completed</h2>
      <p>
        Total duration: {days} days {hours} hours
      </p>

      <table className="summary-table">
        <thead>
          <tr>
            <th>Stage Name</th>
            <th>Visits</th>
            <th>Transition Taken</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          {state.history.map((h, idx) => {
            const dur = h.completedAt
              ? Math.floor(new Date(h.completedAt) - new Date(h.enteredAt))
              : 0;
            const secs = Math.floor(dur / 1000);
            return (
              <tr key={idx}>
                <td>{h.stageName}</td>
                <td>{h.visitIndex}</td>
                <td>{h.transitionLabel || "-"}</td>
                <td>{secs} sec</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="completion-actions">
        <button className="btn-secondary" onClick={() => downloadReport(state)}>
          Export Execution Report
        </button>
        <button className="btn-primary" onClick={onRestart}>
          Start New Run
        </button>
      </div>
    </div>
  );
}
